import * as React from "react";

// Types
import Icon from "../../types/Icon.interface";

const IconCheckmark: React.FC<Icon> = (props: Icon) => {
  const { color = "#e4e8eb", className, style, onClick } = props;

  return (
    <svg
      width={92}
      height={76}
      viewBox="0 0 92 76"
      className={className}
      style={style}
      onClick={onClick}
    >
      <path
        d="M92 8C50.796 35.728 36 76 36 76h-8S14.261 55.084 0 48l4-8c15.718 3.529 28 12 28 12S45.413 24.815 88 0l4 8z"
        fill={color}
        fillRule="nonzero"
      />
    </svg>
  );
};

export default IconCheckmark;
